/**
 * Video Block JavaScript
 * GSAP Flip + ScrollTrigger: element scales/flips between wrapper positions on scroll
 */

(function() {
    'use strict';

    if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined' || typeof Flip === 'undefined') {
        console.warn('[BLOCK] video: GSAP, ScrollTrigger, or Flip not loaded');
        return;
    }

    gsap.registerPlugin(ScrollTrigger, Flip);

    function initFlipOnScroll(block) {
        const wrapperElements = block.querySelectorAll('[data-flip-element="wrapper"]');
        const targetEl = block.querySelector('[data-flip-element="target"]');

        if (!wrapperElements.length || !targetEl) return;

        let tl;

        function flipTimeline() {
            if (tl) {
                tl.kill();
                gsap.set(targetEl, { clearProps: 'all' });
            }

            tl = gsap.timeline({
                scrollTrigger: {
                    trigger: wrapperElements[0],
                    start: 'center center',
                    endTrigger: wrapperElements[wrapperElements.length - 1],
                    end: 'center center',
                    scrub: 0.25
                }
            });

            wrapperElements.forEach(function(element, index) {
                const nextIndex = index + 1;
                if (nextIndex < wrapperElements.length) {
                    const nextWrapperEl = wrapperElements[nextIndex];
                    const nextRect = nextWrapperEl.getBoundingClientRect();
                    const thisRect = element.getBoundingClientRect();
                    const nextDistance = nextRect.top + window.pageYOffset + nextWrapperEl.offsetHeight / 2;
                    const thisDistance = thisRect.top + window.pageYOffset + element.offsetHeight / 2;
                    const offset = nextDistance - thisDistance;

                    tl.add(
                        Flip.fit(targetEl, nextWrapperEl, {
                            duration: offset,
                            ease: 'none'
                        })
                    );
                }
            });
        }

        flipTimeline();

        let resizeTimer;
        window.addEventListener('resize', function() {
            clearTimeout(resizeTimer);
            resizeTimer = setTimeout(flipTimeline, 100);
        });
    }

    function initVideo() {
        const blocks = document.querySelectorAll('.video');

        blocks.forEach(function(block) {
            initFlipOnScroll(block);
        });
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initVideo);
    } else {
        initVideo();
    }
})();